export default __webpack_public_path__ + "static/media/logo-puskarir.03b9644d.svg";